module.exports = __webpack_public_path__ + "static/media/chart-adding-another-v2@4x.2ed9075e.png";